// Dependencies of brooklyn.js
import "lodash";
import "micromodal";
import "scrolltofixed";

// Theme Main JS
import "../vendor/brooklyn";
import "../components/kabia-stock.js";

// Styles
import "../../styles/style.scss";

// Scripts
import "../vendor/slick/slick.js";
import "../vendor/ProxyLink.js";
import "../vendor/TimedPopup.js";
import "../vendor/parsley.js";
import Tabs from "../components/tabs.js";
import "../components/gsap-collapse.js";
import "../components/knitkit.js";
import "../components/input.js";
import "../components/header.js";
import "../components/footer.js";
import "../components/accordion.js";
import "../components/desktop-slider.js";
import "../components/media.js";
import NewsletterForm from "../components/newsletter-form.js";

import "../snippets/product-tile.js";
import "../snippets/wishlist.js";
import "../snippets/geolocation.js";
import "../snippets/collection-filters.js";
import "../snippets/share-buttons.js";
import "../snippets/contact-form.js";
import "../snippets/carousel-banner.js";
import "../snippets/lang-switcher.js";
import "../snippets/country-switcher.js";
import "../snippets/recently-cookie.js";
import "../snippets/announcement-bar.js";

import "../snippets/back-to-top-arrow.js";
import "../sections/newsletter-popup.js";

$(function () {
  Tabs();
  NewsletterForm();

  if (
    typeof window.Ajaxinate !== "undefined" &&
    (document.getElementById("AjaxinateContainer") ||
      document.querySelector(".blog__articles"))
  ) {
    var anchorStart = window.location.href.indexOf("#");
    var itemID =
      anchorStart != -1 ? window.location.href.substr(anchorStart) : "";
    var preLoadingEnded = true; // Flag to check if were loading back pages
    var ajaxPageParamStart = window.location.href.indexOf("?i=");
    var ajaxPageParamEnd =
      anchorStart != -1 ? window.location.href.length - anchorStart : undefined;
    var ajaxPageNumber =
      ajaxPageParamStart != -1
        ? parseInt(
            window.location.href
              .substr(ajaxPageParamStart, ajaxPageParamEnd)
              .replace("?i=", ""),
          )
        : false;

    var preLoadNextPage = function () {
      window.endlessScroll.currentPage++;
      window.endlessScroll.pagesToLoad--;

      window.setTimeout(function () {
        if (window.endlessScroll.nextPageLinkElement) {
          window.endlessScroll.nextPageUrl =
            window.endlessScroll.nextPageLinkElement.getAttribute("href");
          window.endlessScroll.loadMore();
        }
      }, 10); // Please lord of javascript forgive me for this!

      if (!window.endlessScroll.pagesToLoad) {
        preLoadingEnded = true;
      }
    };

    if (document.querySelector(".blog")) {
      const ajaxinateContainer = document.querySelector(".blog__articles");
      const ajaxinatePagination = document.querySelector(".blog__pagination");
      const elementsCounter = document.querySelector(
        ".blog__footer [data-counter]",
      );
      if (
        ajaxinateContainer &&
        ajaxinatePagination &&
        typeof window.Ajaxinate !== "undefined"
      ) {
        window.endlessScroll = new Ajaxinate({
          container: ".blog__articles",
          pagination: ".blog__pagination",
          method: "click",
          callback: function (requestURL) {
            window.pingInit.ajaxinateCallBack(requestURL, ".blog__articles");
            if (elementsCounter) {
              elementsCounter.innerText =
                ajaxinateContainer.querySelectorAll(".blog__article").length;
            }
          },
        });
      }
    } else {
      window.endlessScroll = new Ajaxinate({
        container: "#AjaxinateContainer",
        pagination: "#AjaxinatePagination",
        method: "click",
        callback: function (requestURL) {
          window.pingInit.ajaxinateCallBack(requestURL);
        },
      });
    }

    if (typeof window.endlessScroll !== "undefined") {
      window.endlessScroll.currentPage = 1;
    }

    if (ajaxPageNumber) {
      window.scrollTo({ left: 0, top: 0 });
      preLoadingEnded = false;
      window.endlessScroll.pagesToLoad = ajaxPageNumber - 1;
      preLoadNextPage();
    }
  }

  $("[data-timed-popup]").TimedPopup();

  window.pingInit.ajaxinateCallBack = (
    requestURL,
    ajaxinateSelector = "#AjaxinateContainer",
  ) => {
    const ajaxinateContainer = document.querySelector(ajaxinateSelector);

    if (ajaxinateContainer && window.pingInit.initProductTiles) {
      window.pingInit.initProductTiles(ajaxinateContainer);
    }

    var $proxyLinks = $(ajaxinateSelector).find("[data-link-proxy]");

    if ($proxyLinks.length > 1) {
      $proxyLinks.off("click");

      $proxyLinks.ProxyLink({
        excludes: [
          ".slick-dots",
          ".product-tile__variant",
          ".swym-add-to-wishlist-view-product",
        ],
        onBeforeUnload: function ($proxyLink) {
          const itemID = $proxyLink.data("pid");
          const requestedPageNum = requestURL
            .substr(requestURL.indexOf("?page="))
            .replace("?page=", "");

          if (itemID) {
            history.replaceState(
              {},
              "page " + requestedPageNum,
              "?i=" + requestedPageNum + "#" + itemID,
            );
          } else {
            history.replaceState(
              {},
              "page " + requestedPageNum,
              "?i=" + requestedPageNum,
            );
          }
        },
      });
    } else {
      if (ajaxinateContainer) {
        const ajaxinateElements = ajaxinateContainer.querySelectorAll(
          "[data-ajaxinate-product-id]",
        );
        if (ajaxinateElements && ajaxinateElements.length) {
          Array.from(ajaxinateElements)
            .filter(
              (element) =>
                !!!element.getAttribute("data-ajaxinate-product-initialized"),
            )
            .map((element) => {
              element.setAttribute("data-ajaxinate-product-initialized", true);
            });
        }

        ajaxinateContainer.addEventListener("click", function (e) {
          const clickedElement = e.target.closest(
            "[data-ajaxinate-product-id]",
          );
          if (clickedElement) {
            e.preventDefault();

            const itemID = clickedElement.getAttribute(
              "data-ajaxinate-product-id",
            );
            const requestedPageNum = requestURL
              .substr(requestURL.indexOf("?page="))
              .replace("?page=", "");

            if (itemID) {
              history.replaceState(
                {},
                "page " + requestedPageNum,
                "?i=" + requestedPageNum + "#" + itemID,
              );
            } else {
              history.replaceState(
                {},
                "page " + requestedPageNum,
                "?i=" + requestedPageNum,
              );
            }

            const nextUrl = clickedElement.getAttribute("href");

            if (nextUrl) {
              window.location.href = nextUrl;
            }
          }
        });
      }
    }

    // Init wishlist buttons
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

    // Scroll back to latest position
    var requestedPageNum = requestURL
      .substr(requestURL.indexOf("?page="))
      .replace("?page=", "");

    if (preLoadingEnded) {
      window.endlessScroll.currentPage = requestedPageNum;

      if (itemID) {
        history.replaceState(
          {},
          "page " + requestedPageNum,
          "?i=" + requestedPageNum + itemID,
        );
      } else {
        history.replaceState(
          {},
          "page " + requestedPageNum,
          "?i=" + requestedPageNum,
        );
      }
    }

    if (!window.endlessScroll.pagesToLoad) {
      const headersHeight = $(".site-header").outerHeight(true);

      if (itemID) {
        var itemTop = $(itemID).offset().top - headersHeight;
        window.scrollTo({ left: 0, top: itemTop, behavior: "smooth" });
        itemID = "";
      }
    }

    const plpProducts = document.querySelectorAll(
      ".ajaxinate__wrapper .product-tile__container",
    );
    const plpProductsCountLabel = document.querySelector(
      ".products-count [data-products-count]",
    );
    if (plpProducts && plpProductsCountLabel) {
      const totalProducts = plpProducts.length;
      plpProductsCountLabel.innerText = totalProducts;
    }

    if (window.endlessScroll.pagesToLoad) {
      preLoadNextPage();
    }

    const productsCount = document.querySelectorAll(
      "#AjaxinateContainer .product-tile__container",
    ).length;
    const counterLabel = document.querySelector(
      "[pagination-counter-container] [counter]",
    );
    if (counterLabel) {
      counterLabel.innerText = productsCount;
    }
  };

  const $orderLists = $("[data-order-list]");
  if ($orderLists.length) {
    $orderLists.each(function () {
      const $list = $(this);
      $list
        .find("[data-order-number]")
        .sort(function (a, b) {
          return +a.dataset.orderNumber - +b.dataset.orderNumber;
        })
        .appendTo($list);
    });
    window.setTimeout(function () {
      $orderLists.attr("data-order-list", "ready");
    }, 50);
  }

  if (!window.pingInit) window.pingInit = {};

  window.pingInit.proxyLinkSetup = ($context) => {
    if (!$context || !$context.length) $context = $("body");
    const $proxyLinks = $context.find("[data-link-proxy]");

    if ($proxyLinks.length) {
      $proxyLinks.off("click"); // Removing previous proxy link initialization

      $proxyLinks.ProxyLink({
        excludes: [
          ".slick-dots",
          ".product-tile__variant",
          ".swym-add-to-wishlist-view-product",
        ],
      });
    }
  };
});
